module.exports = __webpack_public_path__ + "img/pari-opportunita-01.0c4fe898.svg";